<template>
  <div id="gwap-body" ref="gwapElement">
    <BlockFrame :header="{title:appletData.name,icon:appletData.icon,more:true,code:'hyyd'}">
      <meetingReservation :applet-data="appletData" />
    </blockframe>
  </div>
</template>

<script>
const moment = require('moment')
import { mapGetters } from 'vuex'
import meetingReservation from './meetingReservation/meetingReservation'

export default {
    // import引入的组件需要注入到对象中才能使用
    name: 'Gwap',
    components: {
        meetingReservation
    },
    props: {
        title: { type: String, default: '' },
        appletData: { type: Object, default: function() { return {} } }
    },
    data() {
        return {
            markDate: '',
            loading: true,
            listdata: [],
            allData: [],
            loginUser: this.$store.getters.loginUser,
            pages: '',
            base_api: process.env.VUE_APP_BASE_API,
            showDialog: false,
            vo: {},
            activeDate: moment(new Date()).format('YYYY/MM/DD')
        }
    },
    computed: {
        ...mapGetters([
            'routes',
            'loginUser'
        ])
    },
    // 监控data中的数据变化
    watch: {

    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.$options.components['BlockFrame'] = this.$loadComponent('@/wapp/common/components/BlockFrame/index')
    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        this.title = this.$tx('hygl.portlet.gwap', '公务安排')
    },
    beforeCreate() {}, // 生命周期 - 创建之前
    beforeMount() {}, // 生命周期 - 挂载之前
    beforeUpdate() {}, // 生命周期 - 更新之前
    updated() {}, // 生命周期 - 更新之后
    beforeDestroy() {}, // 生命周期 - 销毁之前
    destroyed() {}, // 生命周期 - 销毁完成
    activated() {},
    // 方法集合
    methods: {

    }
}
</script>
<style lang='scss' scoped>
// @import url(); 引入公共css类
#gwap-body {
        background-color: #fff;
  width: 100%;
  height: 101%;
  .gwapTitle{
    border-left: 4px solid #1989fa;
    padding: 3px 10px;
    margin: 10px;
    color: #000;
    font-weight: bold;
  }
  /deep/.el-input--prefix .el-input__inner{
      padding-left: 30px;
  }
}
</style>
